import { Content, Portal, Viewport } from '@radix-ui/react-select';
import { cn } from 'cn';

import SelectScrollDownButton from './ui.select-scroll-down-button';
import SelectScrollUpButton from './ui.select-scroll-up-button';

interface Props extends React.ComponentPropsWithoutRef<typeof Content> {
  ref?: React.Ref<React.ElementRef<typeof Content>>;
}

/**
 * @deprecated Use `SelectContent` from `@/ui` for new work — the Radix-free,
 * shadcn-sourced design system. See `.agents/rules/project.md` →
 * "Shared Library Reuse". Kept for existing call sites; do not use in new UI.
 */
function SelectContent({
  className,
  children,
  position = 'popper',
  ref,
  ...props
}: Props) {
  return (
    <Portal>
      <Content
        data-test='select-content'
        ref={ref}
        className={cn(
          'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 max-h-96 min-w-32 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-md',
          position === 'popper' &&
            'data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1',
          className
        )}
        position={position}
        {...props}
      >
        <SelectScrollUpButton />
        <Viewport
          className={cn(
            'p-1',
            position === 'popper' &&
              'h-(--radix-select-trigger-height) w-full min-w-(--radix-select-trigger-width)'
          )}
        >
          {children}
        </Viewport>
        <SelectScrollDownButton />
      </Content>
    </Portal>
  );
}

export default SelectContent;
